<script>
  import { getCondensedOrbitInfo } from '$lib/utils/launch';
  import Icon from '../Icon.svelte';

  /** @type {import('$lib/types/getAllLaunch.js').Launch} */
  export let launch;
</script>

<p class="date mb-32">
  <span class="me-3">
    <Icon icon="calendar" additionalClasses="me-1"></Icon>
    {launch.date}
  </span>
  {#if launch.time}
    <span>
      <Icon icon="clock" additionalClasses="me-1"></Icon>
      {launch.time}
    </span>
  {/if}
</p>

<div class="launch-info">
  <p class="mb-8">
    <Icon icon="rocket" additionalClasses="me-2"></Icon>
    {launch.vehicle.name} - {launch.operator.name}
  </p>
  {#if launch.site}
    <p class="mb-8">
      <Icon icon="location-dot" additionalClasses="me-2"></Icon>
      {launch.site.name} ({launch.site.country})
    </p>
  {/if}
  <p class="mb-0">
    <Icon icon="satellite" additionalClasses="me-2"></Icon>
    {getCondensedOrbitInfo(launch)}
  </p>
</div>

<style>
  .date {
    font-size: 0.8em;
    color: var(--grey-50);
  }

  .launch-info {
    font-size: 1em;
  }

  .launch-info :global(i) {
    width: 1em;
    display: inline-block;
    text-align: center;
  }
</style>
